<template>
    <div>
        <div class="container-fluid">
            <div class="row widget-grid">
                <WelcomeCard />
                <PurchaseSaleCard />
                <OverallBalanceCard />
                <MonthlyProfitsCard />
            </div>
        </div>

    </div>
</template>

<script>

import WelcomeCard from "../../../components/tmkt/dashboard/WelcomeCard.vue";
import PurchaseSaleCard from "../../../components/tmkt/dashboard/PurchaseSaleCard.vue";
import OverallBalanceCard from "../../../components/tmkt/dashboard/OverallBalanceCard.vue";
import MonthlyProfitsCard from "../../../components/tmkt/dashboard/MonthlyProfitsCard.vue";

export default {
    components: {
        WelcomeCard,
        PurchaseSaleCard,
        OverallBalanceCard,
        MonthlyProfitsCard
    },
};
</script>
<style scoped>
.widget-grid {
    padding-top: 50px;
}
</style>